import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import DashboardShell from "@/components/DashboardShell";
import SummaryView from "@/components/SummaryView";
import api from "@/lib/api";

export default function SummaryDetail() {
  const { id } = useParams();
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/summaries/${id}`).then(({ data }) => setSummary(data.summary)).catch(() => setError(true));
  }, [id]);

  return (
    <DashboardShell>
      <Link to="/dashboard" className="mb-6 inline-block text-sm text-zinc-400 hover:text-white" data-testid="summary-back">← Back to dashboard</Link>
      {error ? (
        <p className="text-zinc-400" data-testid="summary-not-found">Summary not found.</p>
      ) : !summary ? (
        <div className="flex items-center gap-3 text-zinc-400"><Loader2 className="h-4 w-4 animate-spin" /> Loading…</div>
      ) : (
        <SummaryView summary={summary} />
      )}
    </DashboardShell>
  );
}
